module.exports = __webpack_public_path__ + "static/example_month-82226004f9b7be3f6835a5990786d0a7.png";